<template>
    <default-sidebar :active="$store.state.sidebars.showPropertyEditForm">
        <property-edit-form :data="$store.state.sidebars.showPropertyEditForm" v-if="$store.state.sidebars.showPropertyEditForm"/>
    </default-sidebar>
</template>

<script>
    import DefaultSidebar from "./DefaultSidebar";
	import PropertyEditForm from "@/components/forms/PropertyEditForm.vue";

    export default {
        name: "DocumentsCreateFormSidebar",
        components: {
            DefaultSidebar,
	        PropertyEditForm
        },
        data() {
            return {

            }
        },
    }
</script>

<style scoped lang="scss">

</style>